// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-management {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1rem;
  gap: 2rem;
}
.stock-management__no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 75vh;
  text-align: center;
  color: #64748B;
}
.stock-management__no-data p {
  margin-bottom: 1rem;
}
.stock-management__no-data .p-button-link {
  color: #4F4BFF;
  text-decoration: underline;
}
.stock-management__no-data .p-button-link:hover {
  color: #3f3ccc;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}

@media screen and (max-width: 768px) {
  .stock-management__header {
    padding: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 0.25rem;
    background: white;
    position: sticky;
    top: 0;
    z-index: 11;
  }
  .stock-management__header .page-hierarchy {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
  .stock-management__header .stock-table__upper {
    position: static;
    margin-top: 1rem;
    padding: 0;
    border: none;
  }
  .stock-management__header .stock-table__upper > span {
    display: none;
  }
  .stock-management__header .stock-table__upper__controls {
    width: 100%;
  }
  .stock-management__header .stock-table__upper__controls .p-inputtext {
    width: 100%;
  }
  .mobile-shop-selector {
    width: 100%;
    margin-top: 0.5rem;
  }
  .mobile-shop-selector__option {
    padding: 0.5rem;
  }
  .mobile-shop-selector__option__name {
    font-size: 1rem;
    color: #4F4BFF;
    margin-bottom: 0.25rem;
  }
  .mobile-shop-selector__option__address {
    font-size: 0.8rem;
    color: #828282;
  }
  .mobile-shop-selector .p-dropdown-label {
    padding: 0.75rem;
  }
}
.mobile-controls .p-inputgroup .p-inputtext {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/stock-management/stock-management.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AACR;AACQ;EACI,mBAAA;AACZ;AAEQ;EACI,cAAA;EACA,0BAAA;AAAZ;AAEY;EACI,cAAA;AAAhB;;AAMA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AAHJ;;AAMA;EAEI;IACE,aAAA;IACA,oBAAA;IACA,gCAAA;IACA,sBAAA;IACA,iBAAA;IACA,gBAAA;IACA,MAAA;IACA,WAAA;EAJJ;EAMI;IACE,iBAAA;IACA,mBAAA;EAJN;EAQI;IACE,gBAAA;IACA,gBAAA;IACA,UAAA;IACA,YAAA;EANN;EAQM;IACE,aAAA;EANR;EASM;IACE,WAAA;EAPR;EASQ;IACE,WAAA;EAPV;EAcA;IACE,WAAA;IACA,kBAAA;EAZF;EAcE;IACE,eAAA;EAZJ;EAcI;IACE,eAAA;IACA,cAAA;IACA,sBAAA;EAZN;EAeI;IACE,iBAAA;IACA,cAAA;EAbN;EAiBE;IACE,gBAAA;EAfJ;AACF;AAqBI;EACE,kBAAA;AAnBN","sourcesContent":[".stock-management {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    padding: 1rem;\n    gap: 2rem;\n\n    &__no-data {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        height: 75vh;\n        text-align: center;\n        color: #64748B;\n        \n        p {\n            margin-bottom: 1rem;\n        }\n\n        .p-button-link {\n            color: #4F4BFF;\n            text-decoration: underline;\n            \n            &:hover {\n                color: #3f3ccc;\n            }\n        }\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n\n@media screen and (max-width: 768px) {\n  .stock-management {\n    &__header {\n      padding: 1rem;\n      padding-bottom: 1rem;  // Reduced from 1.5rem\n      border-bottom: 1px solid #ECECEC;\n      margin-bottom: 0.25rem;  // Reduced from 0.5rem\n      background: white;\n      position: sticky;\n      top: 0;\n      z-index: 11;\n      \n      .page-hierarchy {\n        font-size: 1.2rem;\n        margin-bottom: 1rem;\n      }\n\n      // Move stock table upper controls into header\n      .stock-table__upper {\n        position: static;\n        margin-top: 1rem;\n        padding: 0;\n        border: none;\n\n        > span {\n          display: none; // Hide \"Edit columns\" text\n        }\n\n        &__controls {\n          width: 100%;\n          \n          .p-inputtext {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  .mobile-shop-selector {\n    width: 100%;\n    margin-top: 0.5rem;\n    \n    &__option {\n      padding: 0.5rem;\n      \n      &__name {\n        font-size: 1rem;\n        color: #4F4BFF;\n        margin-bottom: 0.25rem;\n      }\n      \n      &__address {\n        font-size: 0.8rem;\n        color: #828282;\n      }\n    }\n    \n    .p-dropdown-label {\n      padding: 0.75rem;\n    }\n  }\n}\n\n.mobile-controls {\n  .p-inputgroup {\n    .p-inputtext {\n      border-radius: 6px;  // Match the filter button radius\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
